export default __webpack_public_path__ + "locales/pt-BR/Common.json?hash=3850f191e6556048b4352ad7fc2ca4a7";